import Box from "@mui/material/Box";
import { colors } from "../utils/const";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useI18n } from "@/i18n/I18nProvider";

import { Pagination, Navigation, Autoplay } from "swiper";

export default function VerticalCarousel({
  itemsArray,
  Component,
  slidesPerView,
  bg = colors.bg_grey,
  hideDots,
  center = false,
  container = true,
  VerticalPadding = true,
  flag,
  width,
  noShrink,
}) {
  const { locale } = useI18n();

  let dir = locale === "en" ? "left" : "right";
  let dir2 = locale === "en" ? "right" : "left";

  const isCompanyTestimonials =
    itemsArray?.[0]?.avatar ===
    "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/hossam-avatar.jpg";
  const p = VerticalPadding ? "vertical-safe-padding" : "";
  const c = center ? "horizontal-safe-padding" : `section-safe-padding-${dir}`;

  return (
    <Box
      className={`${p} ${c}`}
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        bgcolor: bg,
        p: container == false ? "0 !important" : "",
      }}
    >
      <Box
        sx={{
          width: "100%", // change
          "& .swiper-pagination": {
            // maxWidth: { xs: "60%", sm: "80%" },
            textAlign: dir,
            minHeight: "30px", // Ensure it has enough space for all dots
            overflow: "visible",
          },
          "& .swiper-pagination-bullets": {
          },
          "& .swiper-pagination-bullet": {
            bgcolor: "#000",
            display: { xs: "none", md: hideDots ? "none" : "inline-flex" },
          },
          "& .swiper-button-next": {
            position: "absolute",
            zIndex: "100",
            backgroundImage:
              locale === "en"
                ? "url('/forward1-arrow.png')"
                : "url('https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/back1-arrow.png')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% auto",
            backgroundPosition: "center",
            [dir2]: {
              xs: "10px !important",
              sm: "20px !important",
            },
            [dir]: "auto !important",
            top: isCompanyTestimonials ? "94.5%" : "90%",
            width: "40px !important",
            height: "40px !important",
          },

          "& .swiper-button-prev": {
            position: "absolute",
            zIndex: "100",
            backgroundImage:
              locale === "en"
                ? "url('https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/back1-arrow.png')"
                : "url('/forward1-arrow.png')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% auto",
            backgroundPosition: "center",
            [dir2]: {
              xs: "60px !important",
              sm: "70px !important",
            },
            [dir]: "auto !important",
            top: isCompanyTestimonials ? "94.5%" : "90%",
            width: "40px !important",
            height: "40px !important",
          },

          "& .swiper-button-next::after": {
            display: "none",
          },
          "& .swiper-button-prev::after": {
            display: "none",
          },
        }}
      >
        <Swiper
          showsPagination={false}
          style={{ paddingBottom: locale === "en" ? "80px" : "100px" }}
          pagination={{
            clickable: true,
          }}
          // slidesPerView={1.3}
          slidesPerView={"auto"}
          spaceBetween={20}
          navigation={true}
          modules={[Pagination, Navigation, Autoplay]}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          className="mySwiper"
        >
          {itemsArray?.map(
            (
              {
                avatar,
                name,
                date,
                role,
                rating,
                review,
                img,
                imageUrl,
                title,
                id,
                branches,
                type,
                address,
                areaId,
                latitude,
                longitude,
                phoneNumber,
                Title,
                Description,
                eng_title,
                merchantNameEn,
              },
              index,
            ) => (
              <SwiperSlide
                key={index}
                style={{
                  flexShrink: noShrink ? 0 : 1,
                  width: width,
                }}
              >
                <Component
                  // ReviewCard
                  avatar={avatar}
                  name={name}
                  role={role}
                  flag={flag}
                  rating={rating}
                  review={review}
                  date={date}
                  // MemberCard
                  img={
                    img ||
                    imageUrl ||
                    (type === "offers"
                      ? "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/offer.png"
                      : "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/merchant.png")
                  }
                  // PlaceCard

                  title={title} //  merchants api
                  id={id} //  merchants api
                  branches={branches} //  merchants api
                  type={type}
                  // Nearest Branch Card
                  address={address}
                  areaId={areaId}
                  latitude={latitude}
                  longitude={longitude}
                  phoneNumber={phoneNumber}
                  Title={Title}
                  Description={Description}
                  eng_title={eng_title}
                  merchantNameEn={merchantNameEn || name}
                ></Component>
              </SwiperSlide>
            ),
          )}
        </Swiper>
      </Box>
    </Box>
  );
}
